<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M11.67,1.45A1.44,1.44,0,0,1,13.11,0h5.78a1.44,1.44,0,0,1,1.44,1.45,1.44,1.44,0,0,1-1.44,1.46H13.11A1.44,1.44,0,0,1,11.67,1.45Z" />
    <path
        d="M3,18.91A13,13,0,1,1,16,32,13,13,0,0,1,3,18.91Zm11.56-5.82v5.82A1.44,1.44,0,0,0,16,20.36h5.78a1.46,1.46,0,0,0,0-2.91H17.44V13.09a1.44,1.44,0,1,0-2.88,0Z"
        style="fill-rule:evenodd" />
</svg>
